import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal, Toast } from 'react-bootstrap';
import './field-modal.scss';
import InputMask from 'react-input-mask';
import { useToast } from '../../services/ToastContext';

type Props = {
  title: string;
  description?: string;
  confirmBtnText: string;
  onConfirm: any;
  onCancel?: any;
  field: string;
  value: string;
};

export const FieldModal = forwardRef((props: Props, ref) => {
  useImperativeHandle(ref, () => ({
    handleShow,
    handleCancel,
  }));

  useEffect(() => {
    setFieldValue(props.value);
    setCurrentOwner(props.value);
  }, [props.value, props.field]);

  const [showFieldModal, setShowFieldModal] = useState(false);
  const [fieldValue, setFieldValue] = useState<string>(props.value || '');
  const [currentOwner, setCurrentOwner] = useState<string>();
  const [confirmFieldValue, setConfrimFieldValue] = useState<string>(props.value || '');
  const { showToastMessage } = useToast();
  const handleCancel = () => {
    setShowFieldModal(false);
    if (props.onCancel) props.onCancel();
  };

  const handleConfirm = () => {
    if (!fieldValue || !confirmFieldValue) {
      showToastMessage('Fields are empty');
      return;
    }

    if (fieldValue !== confirmFieldValue) {
      showToastMessage('Emails do not match');
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(fieldValue)) {
      showToastMessage('Invalid email format');
      return;
    }

    props.onConfirm({ type: props.field, value: fieldValue });

    setConfrimFieldValue('');
    setShowFieldModal(false);
  };

  const handleShow = () => setShowFieldModal(true);

  return (
    <section id="field-modal">
      <Modal show={showFieldModal} onHide={handleCancel} centered dialogClassName="global-modal confirm-modal">
        <Modal.Header>{/* <Modal.Title>{props.title}</Modal.Title> */}</Modal.Header>
        <Modal.Body>
          <div className="content">
            {/* <p>Current Owner: {currentOwner}</p> */}
            {props?.field?.includes('Mac') ? (
              <InputMask
                value={fieldValue || ''}
                onChange={(e) => setFieldValue(e.target.value)}
                placeholder={'New ' + props.field}
                mask="**:**:**:**:**:**"
              />
            ) : (
              <div>
                <div className="mb-16">
                  <h3>Change {(props?.field === 'Alternate Email' ? 'Alternate Email' : props.field) + ' Address'}</h3>
                  <div style={{ color: '#101820', opacity: '50%' }}>
                    Enter the {'new ' + (props?.field === 'Alternate Email' ? 'alternate email' : props.field?.toLocaleLowerCase())}
                  </div>
                </div>

                <div className="mb-8">
                  <h6>
                    Your{' '}
                    {'current ' +
                      (props?.field === 'Alternate Email' ? 'alternate email' : props?.field?.toLocaleLowerCase()) +
                      ' address  is:'}
                  </h6>
                  <input className="mb-8 modalField" placeholder={currentOwner} readOnly style={{}}></input>
                </div>
                <div className="mb-8">
                  <h6>
                    Enter your{' '}
                    {'new ' +
                      (props?.field === 'Alternate Email' ? 'alternate email' : props.field?.toLocaleLowerCase()) +
                      ' address'}
                  </h6>
                  <input
                    className="mb-8 modalField"
                    placeholder={'johndoe@gmail.com'}
                    onChange={(e) => setFieldValue(e.target.value)}
                    type={props.field === 'Registered to' ? 'email' : 'text'}
                    style={{}}
                  ></input>
                </div>
                <div className="mb-8">
                  <h6>
                    Confirm your{' '}
                    {'new ' +
                      (props?.field === 'Alternate Email' ? 'alternate email' : props.field?.toLocaleLowerCase()) +
                      ' address'}
                  </h6>
                  <input
                    style={{}}
                    placeholder={'johndoe@gmail.com'}
                    className="modalField"
                    onChange={(e) => setConfrimFieldValue(e.target.value)}
                    required
                  ></input>
                </div>
              </div>
              // <div>
              //   <input className='mb-4' placeholder={'New ' + props.field} onChange={(e) => setFieldValue(e.target.value)} type={props.field === 'Registered to' ? 'email' : 'text'}></input>
              //   <input placeholder={'Confirm'}  onChange={(e) => setConfrimFieldValue(e.target.value)} required></input>
              // </div>
            )}
            <div className="footer mt-14">
              <Button
                onClick={handleCancel}
                variant="light"
                className="back-btn btn-short"
                style={{ border: 'none', borderRadius: '16px', width: '180px' }}
              >
                <span>Cancel</span>
              </Button>

              <Button style={{ border: 'none', borderRadius: '16px', background: '#101820', width: '180px' }} onClick={handleConfirm}>
                {props.confirmBtnText}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
});
